import env from '@beam-australia/react-env';
import { BaseConnector } from './baseConnector';
import { USERCAPACITY_EMPLOYEE } from '../../constants/api';

class AuthenticationConnector extends BaseConnector {
  authorized() {
    var url = `${this.baseApiUrl}/Authentication/Authorized`;
    return this.authFetch(url);
  }

  me() {
    var url = `${this.baseApiUrl}/Authentication/Me`;
    return this.authFetch(url);
  }

  logout(redirectUrl) {
    const a = document.createElement('a');
    const apiKeyFromEnv = env('EXT_X_API_HEADER');
    const apiKey = typeof apiKeyFromEnv !== 'undefined' ? apiKeyFromEnv : null;
    const query = redirectUrl
      ? '?redirectUri=' + redirectUrl + (apiKey ? '&apiKey=' + apiKey : '')
      : '' + (apiKey ? '?apiKey=' + apiKey : '');
    const url = `${this.baseApiUrl}/Authentication/Logout${query}`;

    a.style.display = 'none';
    a.href = url;
    document.body.appendChild(a);
    a.click();
  }

  login(redirectUrl) {
    const a = document.createElement('a');
    const apiKeyFromEnv = env('EXT_X_API_HEADER');
    const apiKey = typeof apiKeyFromEnv !== 'undefined' ? apiKeyFromEnv : null;
    var query = `?loginAs=${USERCAPACITY_EMPLOYEE}`;
    query += redirectUrl
      ? '&redirectUri=' + redirectUrl + (apiKey ? '&apiKey=' + apiKey : '')
      : '' + (apiKey ? '&apiKey=' + apiKey : '');
    const url = `${this.baseApiUrl}/Authentication/Login${query}`;

    a.style.display = 'none';
    a.href = url;
    document.body.appendChild(a);
    a.click();
  }

  getRefreshToken() {
    var url = `${this.baseApiUrl}/Authentication/RefreshToken`;
    return this.authFetch(url);
  }

  renewAccessToken(refreshToken) {
    var url = `${this.baseApiUrl}/Authentication/RenewAccessToken?refreshToken=${refreshToken}`;
    return this.authPost(url);
  }
}

export { AuthenticationConnector };
